<script>
import baseMixin from '@/mixins/baseMixin'
import ClientBookingStatus from '@/shared/constants/booking/ClientBookingStatus'

export default {
  name: 'BookingCardIdLabel',
  mixins: [baseMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isABlockBooking() {
      return !!this.booking?.blockText
    },
    bookingIsPendingApproval() {
      return this.booking.status === ClientBookingStatus.pendingApproval
    },
  },
}
</script>

<template>
  <p class="booking-card__id-label caption mb-0 mr-4 d-flex align-center">
    {{ `#${booking.id}` }}

    <span v-if="isABlockBooking" class="cursor-help">
      <v-tooltip :right="!isMobileViewPort" :top="isMobileViewPort">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            <span class="ml-1"> {{ ` - ${booking.blockText}` }} </span>
          </span>
        </template>
        <span> {{ booking.blockTooltipText }} </span>
      </v-tooltip>
    </span>
  </p>
</template>
